import $ from "jquery";

$("#menu-toggler").click(function () {
	$(this).toggleClass("menu-toggler--opened");
	$("#site-header-menus").toggleClass("menu--opened");
});

$('.header__nav a[href="#"]').click(function (e) {
	e.preventDefault();
});

if (window.matchMedia('(max-width: 1023px)').matches) {
	$("#main-menu .menu-item-has-children").append('<button class="toggle-sub-menu"></button>');

	$("#main-menu .toggle-sub-menu").click(function (e) {
		$(this).parent().toggleClass("menu-item--opened");
	});
}
